import listTable from "./listTable.component";

const listTableModule = angular
  .module("app.components.listTable", [])
  .component("listTable", listTable);

export default listTableModule;



// WEBPACK FOOTER //
// ./src/components/listTable/listTable.module.js